export default function simpleEmailValidation(email) {
  const valid = email.length > 0 && email.includes('@') && email.includes('.');
  return valid;
}
